import { render, staticRenderFns } from "./LayoutBackToOverview.vue?vue&type=template&id=a35c0b60&"
import script from "./LayoutBackToOverview.vue?vue&type=script&lang=ts&"
export * from "./LayoutBackToOverview.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutBackToOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
